import { createSlice } from '@reduxjs/toolkit'

const initialNotificationState = {
    totalUnreadNotificationCount: undefined,
    notifications: []
}

export const NotificationSlices = createSlice({
    name: 'notifications',
    initialState: initialNotificationState,
    reducers: {
        notificationList: (state, action) => {
            state.totalUnreadNotificationCount = action.payload.total_unread_count
            state.notifications = action.payload.notifications
        },
    },
})